import * as type from '../mutation-types';
import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const Laroute = require('../../laroute');

const state = {
    regionList: [],
    lastQuery: null,
};

const mutations = {
    [type.SET_REGION_LIST](state, region) {
        state.regionList = region;
    },

    [type.ADD_REGION](state, region) {
        state.regionList.push(region);
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },
};

const getters = {
    regions(state) {
        return state.regionList;
    },
};

const actions = {
    getRegionListIfNecessary({ commit, dispatch }, params = {}) {
        if (!state.regionList.length || state.lastQuery != params.query) {
            return dispatch('getRegionList', params);
        }

        return Promise.resolve(state.regionList);
    },

    getRegionList({ commit, dispatch }, params) {
        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-region');

        return axios
            .get(Laroute.route('franchise.vue.regions'), options)
            .then(res => {
                let data = res.data.data;

                commit(type.SET_REGION_LIST, data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-region');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-region');
                throw err;
            });
    },

    getRegion({ commit, dispatch }, id) {
        let route = Laroute.route('franchise.region.show', {
            id: id,
        });
        startLoading(dispatch, 'fetch-region');

        return axios
            .get(route)
            .then(res => {
                endLoading(dispatch, 'fetch-region');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-region');
                throw err;
            });
    },

    updateRegion({ commit, dispatch }, region) {
        let route = Laroute.route('franchise.region.update', {
            id: region.id,
        });
        startLoading(dispatch, 'save-region');

        return axios
            .patch(route, region)
            .then(res => {
                endLoading(dispatch, 'save-region');
                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-region');
                throw err;
            });
    },

    createRegion({ commit, dispatch }, region) {
        let route = Laroute.route('franchise.region.store');
        startLoading(dispatch, 'save-region');

        return axios
            .post(route, region)
            .then(res => {
                commit(type.ADD_REGION, res.data);
                endLoading(dispatch, 'save-region');

                return res;
            })
            .catch(err => {
                endLoading(dispatch, 'save-region');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
